<div class="fake-icon">?</div>
<p>
  {{ 'Connecting to TrueNAS' | translate }}
  {{ '... Make sure the TrueNAS system is powered on and connected to the network.' | translate }}
</p>
